import { useRef } from "react";
import Hero from "./HeroSlider";
import About from "./About";
import WorkProcess from "./WorkProcess";
import Services from "./Services";
import Portfolio from "./Portfolio";
import Contact from "./Contact";
import Footer from "./Footer";
import Clients from "./Clients";

function Home({ aboutRef, servicesRef, portfolioRef, contactRef, productRef, dataSecurityRef }) {

  return (
    <div>
      {/* All sections here */}
      <section>
        <Hero />
        <About ref={aboutRef} />
      </section>

      <section ref={servicesRef}>
        <WorkProcess />
        <Services />
      </section>

      <section ref={portfolioRef}>
        <Portfolio />
        <Clients/>
      </section>

      <section ref={contactRef}>
        <Contact />
      </section>

      <Footer />
    </div>
  );
}

export default Home;
